import {containsProfanity} from './profanity.js';

export function rgba2rgb(RGBA_color) {
    const alpha = RGBA_color[3]/255;

    return 'rgb('+Math.floor(((1 - alpha) * 255) + alpha * RGBA_color[0])+','+
        Math.floor(((1 - alpha) * 255) + alpha * RGBA_color[1])+','+
        Math.floor(((1 - alpha) * 255) + alpha * RGBA_color[2])+',1)'
}

const NAME_PREFIXES = [
    'Cool', 'Big', 'Red', 'Blue', 'Fast', 'Shy', 'Tiny', 'Bold',
    'Cozy', 'Zany', 'Chill', 'Glow', 'Hazy', 'Neat', 'Odd',
    'Zen', 'Warm', 'Wild', 'Soft', 'Mega', 'Mini', 'Epic',
];
const NAME_SUFFIXES = [
    'Fox', 'Owl', 'Cat', 'Bear', 'Lynx', 'Panda', 'Otter',
    'Crow', 'Frog', 'Duck', 'Wolf', 'Moth', 'Dove', 'Seal',
    'Hare', 'Newt', 'Yak', 'Elk', 'Puma', 'Wren',
];
const BAD_COMBOS = /ass|cum|fag|nig|tit|dic|fuc|coc|pus|nip|hoe/i;

export function generateUsername() {
    let name;
    do {
        const pre = NAME_PREFIXES[Math.floor(Math.random() * NAME_PREFIXES.length)];
        const suf = NAME_SUFFIXES[Math.floor(Math.random() * NAME_SUFFIXES.length)];
        const num = Math.floor(Math.random() * 100);
        name = pre + suf + num;
    } while (BAD_COMBOS.test(name) || containsProfanity(name));
    return name;
}